import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import styles from './RadioButton.styles';

class RadioButton extends Component {
  handleClick = () => {
    this.props.onChange(this.refs.input.value);
  };
  render() {
    const {
      styles: customStyles,
      name,
      value,
      type,
      label,
      ...rest
    } = this.props;
    return (
      <div
        className={css(styles.base, customStyles)}
        onClick={this.handleClick}
      >
        <input
          ref="input"
          name={name}
          value={value}
          className={css(styles.input)}
          type={type}
          {...rest}
        />
        <span className={css(styles.checkmark)} />
        <span className={css(styles.label)}>{label}</span>
      </div>
    );
  }
}

export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/inputs/radiobutton/RadioButton.js